/**
=========================================================
* Trust Cargo - table rows
=========================================================
*/

// Soft UI Dashboard React base styles
import colors from "assets/theme/base/colors";

// Soft UI Dashboard React helper functions
import rgba from "assets/theme/functions/rgba";

const { primary, dark, grey } = colors;

const tableRow = {
  styleOverrides: {
    root: {
      transition: "background-color 160ms ease, box-shadow 160ms ease",

      /**
       * Very faint striping. On a 700-row order list the eye loses its place
       * between columns; alternating bands fix that. Kept at ~40% of a normal
       * zebra so it guides without turning the table into a barcode.
       */
      "&:nth-of-type(even):not(.MuiTableRow-head)": {
        backgroundColor: rgba(grey[300], 0.18),
      },

      // Hover is gold rather than grey - it confirms the row is interactive
      // and ties back to the rest of the system.
      "&:hover:not(.MuiTableRow-head)": {
        backgroundColor: rgba(primary.main, 0.09),
      },

      "&.Mui-selected, &.Mui-selected:hover": {
        backgroundColor: rgba(primary.main, 0.16),
      },
    },

    head: {
      "&:hover": {
        backgroundColor: "transparent",
      },
    },

    footer: {
      backgroundColor: rgba(dark.main, 0.03),
    },
  },
};

export default tableRow;
